export default __webpack_public_path__ + "static/media/85t.c91c4f76.jpg";